import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import EmpItem from './EmpItem';
import { get_classification_classified, get_classification_unclassified } from '../actions/SubmissionActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import Checkbox from './Checkbox';
import { ApplicationState } from '../reducers/Index';
import { SubmissionsProps } from './Submissions';

class empClassification extends React.Component<RouteComponentProps<{}> & SubmissionsProps, any>{
    constructor(props) {
        super(props);
        this.state = {
            classifed: null,
            unclassified: null,
            isOpenUnclassified: false,
            isOpenClassified: false
        };
    }
    componentDidMount() {
        this.props.get_classification_unclassified(this.props.UserState.display_id).then((unclassified) => {
            this.setState({ unclassified });
        });
        this.props.get_classification_classified(this.props.UserState.display_id).then((classified) => {
            this.setState({ classified });
        });
    }
    componentWillUnmount() {
        this.setState({ classified: null });
        this.setState({ unclassified: null });
    }
    onClickUnclassified = () => {
        this.setState({ isOpenUnclassified: !this.state.isOpenUnclassified });
    }
    onClickClassified = () => {
        this.setState({ isOpenClassified: !this.state.isOpenClassified });
    }
    render() {
        return <div className="employee-classification">
            <div className="emp__header">Employees Occupational Classification</div>
            <div className="emp__searchbar">Search Bar</div>
            <div className="mainsection unclassified">
                <div className="title" onClick={this.onClickUnclassified}>UNCLASSIFIED JOBS {this.state.isOpenUnclassified ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}</div>
                {this.state.isOpenUnclassified ? this.state.unclassified ?
                    <table>
                        <tr>
                            <th>JOB TITLE</th>
                            <th>OCCUPATIONAL<br />CLASSIFICATION</th>
                            <th>OBJECT<br />CODE</th>
                            <th>CFDA<br />FLAG</th>
                            <th>EPSS<br />CLASSIFICATION</th>
                            <th>LAST UPDATED</th>
                            <th></th>
                        </tr>
                        {this.state.unclassified && Object.keys(this.state.unclassified).map((item, index) => {
                            const bodyData = this.state.unclassified[item];
                            return <EmpItem item={item} data={this.state.unclassified} bodyData={bodyData} index={index} />
                        })}
                    </table> : <div style={{ fontSize: '1.4rem', textAlign: 'center' }}>loading <i className="fa fa-spinner fa-spin"></i></div>
                    : null
                }
            </div>
            <div className="mainsection classified">
                <div className="title" onClick={this.onClickClassified}>CLASSIFIED JOBS {this.state.isOpenClassified ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}</div>
                {this.state.isOpenClassified ? this.state.classified ?
                    <table>
                        <tr>
                            <th>JOB TITLE</th>
                            <th>OCCUPATIONAL<br />CLASSIFICATION</th>
                            <th>OBJECT<br />CODE</th>
                            <th>CFDA<br />FLAG</th>
                            <th>EPSS<br />CLASSIFICATION</th>
                            <th>LAST UPDATED</th>
                            <th></th>
                        </tr>
                        {this.state.classified && Object.keys(this.state.classified).map((item, index) => {
                            const bodyData = this.state.classified[item];
                            return <EmpItem item={item} data={this.state.classified} bodyData={bodyData} index={index} />
                        })}
                    </table> : <div style={{ fontSize: '1.4rem', textAlign: 'center' }}>loading <i className="fa fa-spinner fa-spin"></i></div>
                    : null
                }
            </div>
        </div>
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties
});


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            get_classification_classified: get_classification_classified,
            get_classification_unclassified: get_classification_unclassified
        }, dispatch
    )
}


export default connect(
    mapStateToProps, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(empClassification);